// src/components/RandomAd.js
import React, { useState, useEffect } from "react";
import adsData from "../data/ads.json"; // Direct import like SkillsMapper
import "./RandomAd.css";

const RandomAd = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    if (adsData && adsData.length > 0) {
      const randomIndex = Math.floor(Math.random() * adsData.length);
      setAd(adsData[randomIndex]);
    }
  }, []);

  if (!ad) return null;

  return (
    <a
      href={ad.urls}
      target="_blank"
      rel="noopener noreferrer"
      className="random-ad-link"
    >
      <img src={`/${ad.imgName}`} alt="Advertisement" />
    </a>
  );
};

export default RandomAd;